<template>
  <div class="reactive-pagination text-center" v-if="displayBlock()">
    <div>
      <button class="btn btn-dark" v-if="displayButton()" @click="next">
        <font-awesome-icon icon="plus" />
        Ladda {{ nextCount() }} till
      </button>
    </div>
    <div>
      <small class="text-muted">
        Visar {{ displayedCount() }} av {{ pagination.total }}
      </small>
    </div>
  </div>
</template>

<script>

  export default {
    name: "Pagination",
    props: ['pagination', 'next'],
    methods: {
      displayedCount(){
        return (this.pagination.current_page - 1) * this.pagination.per_page + this.pagination.count
      },
      nextCount(){
        if(this.isBeforeLastPage() === false){
          return this.pagination.per_page
        }

        return this.pagination.total - this.displayedCount()
      },
      isLastPage(){
        return this.pagination.current_page === this.pagination.total_pages
      },
      isBeforeLastPage(){
        return this.pagination.current_page === this.pagination.total_pages - 1
      },
      displayBlock(){
        return this.pagination.total_pages > 1
      },
      displayButton(){
        return this.isLastPage() === false
      },
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Partials/Pagination.vue